import React, { Component } from 'react';
import { DISPATCH_ID } from '../libs/utils/Const';
import { connect } from 'react-redux';
import '../css/dataTables.css';
import $ from 'jquery';
import AreYouAgreeModal from './AreYouAgreeModal';


class ConfigurationPointsCardModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeModalConfiguration = async () => {
        const { GetAllConfiguration } = this.props;
        await GetAllConfiguration()
        $('#configurationPointsCard').modal('hide');
    };

    closeAction = () => {
        const { cleanData } = this.props;
        $('#configurationPointsCard').on('hide.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const {
            PointsCardModel,
            Add_Definitions,
            Delete_Definitions,
            change_Name,
            change_MinAmount,
            change_MaxAmount,
            change_PerAmount,
            change_Points,
            // change_RegularProfit,
            // change_SpecialProfit,
            change_PerSpecial,

            activeShowAreYouAgreeModal,
            showAreYouAgreeModal,
            Add_newDefinition,
            CloseShowAreYouAgreeModal,
            formatNumber,
        } = this.props;

        let action = 1;
        let editMode = false;
        return (

            <>
                <div className="modal fade bd-example-modal-xl modal-open scroll"
                    id="configurationPointsCard"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true">

                    <div className="modal-dialog modal-xl modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white"
                                style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">
                                    Configuración de Monedero Electrónico
                                </h4>
                                <button type="button" className="close" onClick={this.closeModalConfiguration} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">
                                        &times;
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div>
                                                <div className="row">
                                                    <div className='col-12 text-right'>
                                                        <button type="button" className="btn btn-primary mb-3 mr-2" onClick={() => Add_Definitions()} disabled={action === 2 && !editMode ? true : false}>
                                                            <i className="fa fa-plus-circle ml-1" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="container col-md-12" >
                                                    <div className="table-responsive" style={{ marginBottom: 0, height: 400, maxHeight: 400, overflow: 'auto', fontSize: "13px", fontWeight: "bold" }}>
                                                        <table id="tablaDefinitions" className="table table-hover" >
                                                            <thead >
                                                                <tr className="" style={{/*background: '#2d75bd', borderRadius: '0' */ }} >
                                                                    {/* <th >#</th> */}
                                                                    <th className="text-center" scope="col">Nivel</th>
                                                                    <th className="text-center" scope="col">Monto Minimo</th>
                                                                    <th className="text-center" scope="col">Monto Maximo</th>
                                                                    <th className="text-center" scope="col">Por Cada</th>
                                                                    <th className="text-center" scope="col">Puntos</th>
                                                                    <th className="text-center" scope="col">Utilidad</th>
                                                                    <th className="text-center" scope="col">Utilidad Especiales</th>
                                                                    <th className="text-center" scope="col">Por Cada Especiales</th>
                                                                    <th className="text-center" scope="col"></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody style={{ overflowY: 'auto' }}>
                                                                {!!PointsCardModel.Definitions && PointsCardModel.Definitions.map((definition, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            {/* <th >{index + 1}</th> */}
                                                                            {/* Nivel */}
                                                                            <td className="text-center">
                                                                                {definition.isNew ?
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        value={definition.name ? definition.name : ''}
                                                                                        disabled={(action === 2 && !editMode) || (index + 1 !== PointsCardModel.Definitions.length) ? true : false}
                                                                                        onFocus={(event) => event.target.select()}
                                                                                        onChange={event => change_Name(event, index)}
                                                                                        style={{ width: '120px' }}
                                                                                    />
                                                                                    :
                                                                                    (definition.name ? definition.name : '')
                                                                                }
                                                                            </td>
                                                                            {/* Monto Minimo */}
                                                                            <td className="text-right">
                                                                                {definition.isNew ?
                                                                                    <input
                                                                                        type="number"
                                                                                        min="0"
                                                                                        className="form-control"
                                                                                        value={definition.MinAmount ? definition.MinAmount : ''}
                                                                                        disabled={(action === 2 && !editMode) || (index + 1 !== PointsCardModel.Definitions.length) ? true : false}
                                                                                        onFocus={(event) => event.target.select()}
                                                                                        onChange={event => change_MinAmount(event, index)}
                                                                                        style={{ width: '120px' }}
                                                                                    />
                                                                                    :
                                                                                    (definition.MinAmount ? formatNumber.new(definition.MinAmount) : '')
                                                                                }
                                                                            </td>
                                                                            {/* Monto Maximo */}
                                                                            <td className="text-right">
                                                                                {definition.isNew ?
                                                                                    <input
                                                                                        type="number"
                                                                                        min="0"
                                                                                        className="form-control"
                                                                                        value={definition.MaxAmount ? definition.MaxAmount : ''}
                                                                                        disabled={(action === 2 && !editMode) || (index + 1 !== PointsCardModel.Definitions.length) ? true : false}
                                                                                        onFocus={(event) => event.target.select()}
                                                                                        onChange={event => change_MaxAmount(event, index)}
                                                                                        style={{ width: '120px' }}
                                                                                    />
                                                                                    :
                                                                                    (definition.MaxAmount ? formatNumber.new(definition.MaxAmount) : '')
                                                                                }
                                                                            </td>
                                                                            {/* Por Cada */}
                                                                            <td className="text-right">
                                                                                {definition.isNew ?
                                                                                    <input
                                                                                        type="number"
                                                                                        min="0"
                                                                                        className="form-control"
                                                                                        value={definition.PerAmount ? definition.PerAmount : ''}
                                                                                        disabled={(action === 2 && !editMode) || (index + 1 !== PointsCardModel.Definitions.length) ? true : false}
                                                                                        onFocus={(event) => event.target.select()}
                                                                                        onChange={event => change_PerAmount(event, index)}
                                                                                        style={{ width: '120px' }}
                                                                                    />
                                                                                    :
                                                                                    (definition.PerAmount ? formatNumber.new(definition.PerAmount) : '')
                                                                                }
                                                                            </td>
                                                                            {/* Puntos */}
                                                                            <td className="text-center">
                                                                                {definition.isNew ?
                                                                                    <input
                                                                                        type="number"
                                                                                        min="0"
                                                                                        className="form-control"
                                                                                        value={definition.Points ? definition.Points : ''}
                                                                                        disabled={(action === 2 && !editMode) || (index + 1 !== PointsCardModel.Definitions.length) ? true : false}
                                                                                        onFocus={(event) => event.target.select()}
                                                                                        onChange={event => change_Points(event, index)}
                                                                                        style={{ width: '120px' }}
                                                                                    />
                                                                                    :
                                                                                    (definition.Points ? definition.Points : '')
                                                                                }
                                                                            </td>
                                                                            {/* Utilidad */}
                                                                            <td className="text-right">
                                                                                {
                                                                                    (definition.RegularProfit ? definition.RegularProfit : '')
                                                                                }
                                                                            </td>
                                                                            {/* Utilidad Especiales */}
                                                                            <td className="text-right">
                                                                                {
                                                                                    (definition.SpecialProfit ? definition.SpecialProfit : '')
                                                                                }
                                                                            </td>
                                                                            {/* Por Cada Especiales */}
                                                                            <td className="text-right">
                                                                                {definition.isNew ?
                                                                                    <input
                                                                                        type="number"
                                                                                        min="0"
                                                                                        className="form-control"
                                                                                        value={definition.PerSpecial ? definition.PerSpecial : ''}
                                                                                        disabled={(action === 2 && !editMode) || (index + 1 !== PointsCardModel.Definitions.length) ? true : false}
                                                                                        onFocus={(event) => event.target.select()}
                                                                                        onChange={event => change_PerSpecial(event, index)}
                                                                                        style={{ width: '120px' }}
                                                                                    />
                                                                                    :
                                                                                    (definition.PerSpecial ? formatNumber.new(definition.PerSpecial) : '')
                                                                                }
                                                                            </td>
                                                                            {/* ELIMINAR */}
                                                                            <td className="text-center">
                                                                                {definition.isNew &&
                                                                                    <button type="button" className="btn btn-danger" onClick={() => Delete_Definitions(index)} disabled={action === 2 && !editMode ? true : false}>
                                                                                        <i className="fa fa-trash pl-1" aria-hidden="true"></i>
                                                                                    </button>
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeModalConfiguration} >Cerrar</button>
                                <button type="button" className="btn botonCorrect text-black" onClick={activeShowAreYouAgreeModal} >Guardar Cambios</button>
                            </div>
                        </div>
                    </div>
                </div>
                {showAreYouAgreeModal &&
                    <AreYouAgreeModal
                        mensaje={'¿Estás seguro que deseas agregar la nueva definición de nivel?'}
                        accept={Add_newDefinition}
                        cancel={CloseShowAreYouAgreeModal}
                    />
                }
            </>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfigurationPointsCardModal);